"use client";

import { useState } from "react";
import { sendFeedback } from "@/utils/api";

export default function FeedbackModal({ onClose, user }) {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (data) => {
    if (submitting) return;

    try {
      setSubmitting(true);

      await sendFeedback({
        ...data,
        piUsername: user?.piUsername,
        userId: user?._id || user?.id || user?.uid || null,
        timestamp: new Date().toISOString(),
      });

      setSubmitted(true);
      setTimeout(() => onClose?.(), 800);
    } catch (err) {
      // keep UI alive (no crash)
      console.error("❌ Feedback submission failed:", err);
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
        <div className="bg-white p-6 rounded-xl text-center shadow-xl">
          🙏 Thanks for your feedback!
        </div>
      </div>
    );
  }

  return (
    <div
      className="fixed inset-0 bg-black/70 flex items-center justify-center z-50"
      role="dialog"
      aria-modal="true"
    >
      <div className="bg-white rounded-xl p-6 text-center shadow-lg w-80">
        <h3 className="text-lg font-semibold mb-3">Enjoying ReloadPi?</h3>
        <p className="text-sm text-gray-600 mb-4">
          Your feedback helps us improve.
        </p>

        <div className="flex justify-center gap-2 mb-4">
          {[1, 2, 3, 4, 5].map((n) => (
            <button
              key={n}
              type="button"
              disabled={submitting}
              onClick={() => submit({ rating: n })}
              className="text-2xl hover:scale-110 transition disabled:opacity-50"
              aria-label={`Rate ${n} out of 5`}
            >
              {n <= 3 ? "😐" : "😊"}
            </button>
          ))}
        </div>

        <button
          type="button"
          disabled={submitting}
          onClick={() => submit({ skipped: true })}
          className="text-xs text-gray-500 hover:underline disabled:opacity-50"
        >
          Skip for now
        </button>
      </div>
    </div>
  );
}
